export default __webpack_public_path__ + "static/cloud-differences-cf24f9d6406542cbaa9438157cc7e226.webp";